export default __webpack_public_path__ + "static/media/smileOne.684e062d.svg";